









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IInfluxDBConfiguration } from "sitewhere-configuration-model";

import { ContentField } from "sitewhere-ide-components";
import { VCard } from "vuetify/lib";

@Component({
  components: { VCard, ContentField }
})
export default class InfluxDbSummary extends Vue {
  @Prop() readonly configuration!: IInfluxDBConfiguration;

  /** Hostname */
  get hostname(): string | null {
    return this.configuration ? this.configuration.hostname : null;
  }

  /** Port */
  get port(): number | null {
    return this.configuration ? this.configuration.port : null;
  }

  /** Application */
  get databaseName(): string | null {
    return this.configuration ? this.configuration.databaseName : null;
  }
}
